export const BUSINESS = {
  name: 'Fremont Auto Tech',
  nameKorean: '프리몬트 자동차 정비',
  phone: '+15107965599',
  phoneFormatted: '(510) 796-5599',
  address: {
    street: '4546 Peralta Blvd #21',
    city: 'Fremont',
    state: 'CA',
    zip: '94536',
    full: '4546 Peralta Blvd #21, Fremont, CA 94536',
  },
  hours: {
    weekdays: 'Mon-Fri: 9:00AM - 6:30PM',
    saturday: 'Sat: 9:00AM - 5:00PM',
    sunday: 'Sun: Closed',
  },
  email: 'fremontautotech@yahoo.com',
  website: 'https://www.fremontautotech.com',
  googleMapsUrl: 'https://maps.app.goo.gl/Hf2vWhbeAf19fWQD9',
  yelpUrl: 'https://www.yelp.com/biz/fremont-auto-tech-fremont',
  rating: '4.5',
  googleRating: '4.5',
  yelpRating: '5.0',
  googleReviewCount: '42',
  yelpReviewCount: '33',
  reviewCount: '75',
  yearEstablished: 1992,
  tagline: "Your Go-To Asian Auto Repair Shop \u2014 Since 1992",
  owner: 'Tony',
  languages: ['English', 'Korean'],
  specialty: [
    'Acura', 'Genesis', 'Honda', 'Hyundai', 'Infiniti', 'Kia',
    'Lexus', 'Mazda', 'Mitsubishi', 'Nissan', 'Subaru', 'Toyota',
  ],
  photos: {
    exterior: '/photos/fremont-auto-tech-shop-exterior.jpg',
    waitingRoom: '/photos/fremont-auto-tech-waiting-room.jpg',
    servicePrices: '/photos/fremont-auto-tech-service-prices.jpg',
    frontDesk: '/photos/fremont-auto-tech-front-desk.jpg',
    serviceBay: '/photos/nissan-altima-service-bay.jpg',
    tpmsInfoGraphic: '/photos/tpms-sensor-infographic.png',
  },
}
